export const reduceUpdateBoardRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingBoard: true },
  };
};

export const reduceUpdateBoardSuccess = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingBoard: false },
  };
};

export const reduceUpdateBoardFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingBoard: false },
  };
};
